<template>
  <div>
    <h1>Email panels</h1>
    <v-btn :to="{ name: 'emailPanelSalesAdd' }"><v-icon>add</v-icon> Add</v-btn>
    <v-data-table
      :pagination.sync="pagination"
      :headers="headers"
      :items="emailPanels"
      class="elevation-1"
      v-if="emailPanels"
    >
      <template v-slot:items="props">
        <tr>
          <td>
            <v-btn
              :to="{
                name: 'emailPanelSales',
                params: { id: props.item.id }
              }"
              small
              >{{ props.item.id }}</v-btn
            >
          </td>
          <td>{{ props.item.heading }}</td>
          <td>{{ props.item.subheading }}</td>
          <td>
            <div
              :style="`background:${props.item.background};height:25px;width:75px;`"
            ></div>
          </td>
          <td>
            <div
              :style="`background:${props.item.colour};height:25px;width:75px;`"
            ></div>
          </td>
          <td>{{ buttons.find((i) => props.item.button == i.id).name }}</td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
import { buttonList } from "@/util/helpers";
export default {
  name: "EmailPanels",
  metaInfo() {
    return {
      title: "Email Panels",
      titleTemplate: "%s - Sales - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  data() {
    return {
      quoteTypes: null,
      emailPanels: null,
      headers: [
        {
          text: "Id",
          value: "id"
        },
        {
          text: "Heading",
          value: "heading"
        },
        {
          text: "Subheading",
          value: "subheading"
        },
        {
          text: "Background colour",
          value: "background"
        },
        {
          text: "Text colour",
          value: "colour"
        },
        {
          text: "Button",
          value: "button"
        }
      ],
      pagination: {
        rowsPerPage: -1,
        sortBy: "name",
        descending: false
      },
      buttons: null
    };
  },
  methods: {
    async fetchEmailPanels() {
      const response = await nbmlaw.get(`/cors/admin/sales/emailPanels`);
      //   console.log(response.data);
      this.emailPanels = response.data;
    }
  },
  created() {
    this.fetchEmailPanels();
    this.buttons = buttonList();
  }
};
</script>